import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a76b64b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-subtitle-1 font-weight-medium" }, "Ligas asociadas:", -1))
const _hoisted_3 = {
  key: 1,
  class: "text-medium-emphasis text-body-2"
}

import { ref, onMounted } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import {
  addTorneoToLigaAsync,
  deleteLigaTorneoAsync,
  getLigasAsocidasATorneoAsync,
  getLigasNoTorneoAsync,
} from "@/services/LigasService";
import { AddLigaTorneoDTO, LigaDTO } from "@/interfaces/Liga";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardAddTorneoLiga',
  props: {
    idTorneo: {}
  },
  setup(__props: any) {

const props = __props;

const ligasDisponibles = ref<LigaDTO[]>([]);
const ligasAsociadas = ref<LigaDTO[]>([]);
const isGenerating = ref(false);
const showErrorModal = ref(false);
const showSuccessModal = ref(false);
const ligaSelected = ref<LigaDTO>();

const cargarLigas = async () => {
  try {
    const [noAsociadasRes, asociadasRes] = await Promise.all([
      getLigasNoTorneoAsync(props.idTorneo),
      getLigasAsocidasATorneoAsync(props.idTorneo),
    ]);

    ligasDisponibles.value = noAsociadasRes.data;
    ligasAsociadas.value = asociadasRes.data;
  } catch (error) {
    console.error("Error al cargar ligas:", error);
    showErrorModal.value = true;
  }
};

const confirmar = async () => {
  if (!ligaSelected.value || props.idTorneo === 0) return;

  try {
    isGenerating.value = true;

    const request: AddLigaTorneoDTO = {
      idLiga: ligaSelected.value.idLiga,
      idTorneo: props.idTorneo,
    };

    await addTorneoToLigaAsync(request);
    showSuccessModal.value = true;
    ligaSelected.value = undefined;
    await cargarLigas();
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
  }
};

const eliminarLiga = async (idLiga: number) => {
  try {
    isGenerating.value = true;
    await deleteLigaTorneoAsync(props.idTorneo, idLiga);
    await cargarLigas();
  } catch (error) {
    console.error("Error al eliminar liga del torneo", error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
  }
};

onMounted(async () => {
  if (props.idTorneo !== 0) {
    await cargarLigas();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "border",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              label: "Selecciona una liga",
              items: ligasDisponibles.value,
              modelValue: ligaSelected.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ligaSelected).value = $event)),
              "item-title": "nombreLiga",
              "item-value": "idLiga",
              "return-object": "",
              variant: "outlined",
              clearable: "",
              disabled: ligasDisponibles.value.length === 0
            }, null, 8, ["items", "modelValue", "disabled"]),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer, { class: "my-4" }),
                _createVNode(_component_v_btn, {
                  disabled: isGenerating.value || !ligaSelected.value,
                  onClick: confirmar,
                  color: "primary",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Añadir ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "my-4" }),
            (ligasAsociadas.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ligasAsociadas.value, (liga) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: liga.idLiga
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-trophy" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              icon: "mdi-close",
                              size: "small",
                              color: "red",
                              variant: "text",
                              onClick: ($event: any) => (eliminarLiga(liga.idLiga))
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(liga.nombreLiga), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, " No hay ligas asociadas aún. "))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo añadido a la liga con éxito.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "Ha ocurrido un error. Inténtalo de nuevo o contacta al administrador.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})